import React from 'react';

import { getTrophyStyle } from '.';
import { getNumberWithOrdinal } from 'functions/numberFunctions';
import { Link } from 'components/FormComponents/FormComponents';
import {
  SkillContainer,
  SkillHeader,
  TrophyIcon,
  Container,
  ChallengeSticker,
  ChallengeStickerContent,
  ChallengeStickerTimeLeft,
  ChallengeContainer,
  ChallengeStickerHeader,
  ChallengeName,
  ChallengeParticipants,
  ChallengeStickerTrophy,
  PlacementLabel,
  ChallengeDate,
  ChallengeEmptyText,
  ChallengeScore,
} from './styles';

export default function ChallengeTab({ profile }) {
  const { challenges, tournaments } = profile;

  const renderChallenge = (challenge, index) => {
    let trophyStyle;
    switch (challenge.placement) {
      case 1:
        trophyStyle = getTrophyStyle('gold');
        break;
      case 2:
        trophyStyle = getTrophyStyle('silver');
        break;
      case 3:
        trophyStyle = getTrophyStyle('bronze');
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        trophyStyle = getTrophyStyle('top10');
        break;
      default:
        break;
    }
    return (
      <Link to={`/challenges/${challenge._id}`} key={index}>
        <ChallengeSticker key={challenge.name} image={challenge.contestBackground}>
          <ChallengeStickerContent>
            <ChallengeStickerHeader>
              <ChallengeStickerTimeLeft>
                {parseInt(challenge.daysLeft) < 0 || parseInt(challenge.daysLeft) === 0 ? 0 : challenge.daysLeft}
              </ChallengeStickerTimeLeft>
              {challenge.date && <ChallengeDate>{challenge.date}</ChallengeDate>}
              {challenge.participants && <ChallengeParticipants>{challenge.participants}</ChallengeParticipants>}
            </ChallengeStickerHeader>
            <ChallengeName>{challenge.name}</ChallengeName>
            <ChallengeScore>Score: {challenge.score}</ChallengeScore>
          </ChallengeStickerContent>
          {challenge.placement && (
            <ChallengeStickerTrophy>
              {trophyStyle && <TrophyIcon size={36} rgb={trophyStyle.color} icon={trophyStyle.icon} />}
              <PlacementLabel>{getNumberWithOrdinal(challenge.placement)}</PlacementLabel>
            </ChallengeStickerTrophy>
          )}
        </ChallengeSticker>
      </Link>
    );
  };

  return (
    <Container>
      <SkillContainer height={'auto'}>
        <SkillHeader>Latest tournaments</SkillHeader>
        <ChallengeContainer>
          {tournaments && tournaments.length > 0 ? (
            tournaments.map(renderChallenge)
          ) : (
            <ChallengeEmptyText>You have not participated in any tournaments yet...</ChallengeEmptyText>
          )}
        </ChallengeContainer>
      </SkillContainer>
      <SkillContainer height={'auto'} style={{ marginRight: 0 }}>
        <SkillHeader>Latest challenges</SkillHeader>
        <ChallengeContainer>
          {challenges && challenges.length > 0 ? (
            challenges.map(renderChallenge)
          ) : (
            <ChallengeEmptyText>You have not participated in any challenges yet...</ChallengeEmptyText>
          )}
        </ChallengeContainer>
      </SkillContainer>
    </Container>
  );
}
